import * as React from "react";
import { makeStyles } from "@mui/styles";
import { Box, LinearProgress } from "@mui/material";

const useStyles = makeStyles((theme) => ({
  root: {
    height: 5,
    backgroundColor: "transparent !important",
  },
  bar: {
    backgroundColor: "#39DB8D !important", 
    borderRadius: "5px",
  },
}));

interface CustomLinearProgressBarProps {
  startProgress?: boolean;
  stopProgress?: boolean;
  syncProgress?: boolean
}

export const CustomLinearProgressBar: React.FC<CustomLinearProgressBarProps> = ({ startProgress = true, stopProgress = false, syncProgress= false}) => {
  const classes = useStyles();

  const [progress, setProgress] = React.useState(0);
  const timerRef = React.useRef<number | null>(null);

  React.useEffect(() => {
    if (startProgress) {
      timerRef.current = window.setInterval(() => {
        setProgress((oldProgress) => Math.min(oldProgress + (syncProgress ? 1 : 10), 100));
      }, 100);
    }

    return () => {
      if (timerRef.current) {
        clearInterval(timerRef.current);
      }
    };
  }, [startProgress]);

  React.useEffect(() => {
    if (stopProgress) {
      setProgress(100);
    }
  }, [stopProgress]);

  return (
    <Box sx={{ width: '100%' }}>
      <LinearProgress variant="determinate" value={progress} classes={{ root: classes.root, bar: classes.bar }} />
    </Box>
  );
};
